export default "__VITE_ASSET__Btz9KmqM__"